import { Box, Container } from '@mui/material';
import _ from 'lodash';
import React from 'react';

import { SPACE } from '@/constants';
import { PrimaryButton, SecondaryButton } from '@/components/button';
import FilterIcon from '@/components/icons/filter-icon';
import { iconNames } from '@/components/icons';
import { Panel } from '@/components/panel';

import ChipsForFilters from './chips-for-filters';
import { Filter, Column, Divider, FilterHeader, SelectionPanel, StyledIcon } from './styles';

const DiscoveryFilterMobile = ({
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'uiSelectedPriceRange' implicitly has an 'any' type.
  uiSelectedPriceRange,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'reset' implicitly has an 'any' type.
  reset,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'resetSelectedPriceRange' implicitly has an 'any' type.
  resetSelectedPriceRange,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'filterConfig' implicitly has an 'any' type.
  filterConfig,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'currentlyOpenFilter' implicitly has an 'any' type.
  currentlyOpenFilter,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'safetyFeatures' implicitly has an 'any' type.
  safetyFeatures,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'toggleCurrentlyOpenFilter' implicitly has an 'any' type.
  toggleCurrentlyOpenFilter,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'filterState' implicitly has an 'any' type.
  filterState,
}) => {
  const [isOpen, setIsOpen] = React.useState();

  return (
    <>
      <FilterHeader>
        <Container maxWidth="xl">
          <Box py={SPACE.X1}>
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Argument of type 'true' is not assignable to parameter of type 'SetStateAction<undefined>'. */}
            <SecondaryButton type="button" startIcon={<FilterIcon />} onClick={() => setIsOpen(!isOpen)}>
              Edit Filters
            </SecondaryButton>
          </Box>
        </Container>
      </FilterHeader>
      <Container maxWidth="xl">
        <ChipsForFilters
          {...{
            uiSelectedPriceRange,
            reset,
            resetSelectedPriceRange,
            filterConfig,
            safetyFeatures,
            displayClearLink: true,
            filterState,
          }}
        />
      </Container>
      {_.map(filterConfig, (field) => (
        <span key={field.id}>{field.content(false)}</span>
      ))}
      {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'string' is not assignable to type 'null | undefined'. */}
      <Panel anchor="right" ariaLabelledBy="discovery-filters" isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <Box mx={SPACE.X2} my={SPACE.X1}>
          <Box id="discovery-filters" component="h1" mt={SPACE.X4} tabIndex={-1}>
            Filter cars by
          </Box>
          <Box>
            <ChipsForFilters
              {...{
                uiSelectedPriceRange,
                reset,
                resetSelectedPriceRange,
                filterConfig,
                safetyFeatures,
                displayClearLink: true,
                filterState,
              }}
            />
          </Box>
          <Box>
            <Column>
              {_.map(filterConfig, (field) => (
                <span key={field.id}>
                  <Filter
                    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: Element[]; isOpen: boolean; onClick: () => any; onKeyDown: (event: KeyboardEvent<HTMLLIElement>) => void; role: "button"; tabIndex: number; "aria-expanded": boolean; }' is not assignable to type 'IntrinsicAttributes & { theme?: Theme | undefined; as?: ElementType<any, keyof IntrinsicElements> | undefined; } & ClassAttributes<...> & LiHTMLAttributes<...>'.
                    isOpen={currentlyOpenFilter === field.id}
                    onClick={() => toggleCurrentlyOpenFilter(field.id)}
                    onKeyDown={(event) => {
                      if (event.key === ' ') {
                        event.preventDefault();
                        toggleCurrentlyOpenFilter(field.id);
                      }
                    }}
                    role="button"
                    tabIndex={0}
                    aria-expanded={field.id === currentlyOpenFilter}
                  >
                    <h5>{field.name}</h5>
                    {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ isOpen: boolean; name: "filter" | "visibility" | "caret" | "download" | "close" | "compareCar" | "cross" | "expand" | "didYouKnow" | "facebook" | "hamburger" | "instagram" | "linkActive" | ... 12 more ... | "warning"; }' is not assignable to type 'IntrinsicAttributes & IconProps & { theme?: Theme | undefined; }'. */}
                    <StyledIcon isOpen={currentlyOpenFilter === field.id} name={iconNames.expand} />
                  </Filter>

                  <SelectionPanel hidden={currentlyOpenFilter !== field.id}>{field.content()}</SelectionPanel>
                  {field.id !== _.last(_.keys(filterConfig)) && <Divider />}
                </span>
              ))}
            </Column>
          </Box>
          <Box mt={SPACE.X3} mb={SPACE.X2}>
            <PrimaryButton
              fullWidth
              onClick={() => {
                // @ts-expect-error [🤖 PLEASE FIX 🤖]: Argument of type 'false' is not assignable to parameter of type 'SetStateAction<undefined>'.
                setIsOpen(false);
              }}
            >
              Show results
            </PrimaryButton>
          </Box>
        </Box>
      </Panel>
    </>
  );
};

export default DiscoveryFilterMobile;
